// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--3lPMH";
export const footerMain = "footer-module--footer-main--2SNCx";
export const footerInfoContainer = "footer-module--footer-info-container--3EltM";
export const footerInfoLogo = "footer-module--footer-info-logo--2u9Kl";
export const footerInfo = "footer-module--footer-info--BfWPp";
export const footerNavContainer = "footer-module--footer-nav-container--3IO09";
export const footerLegal = "footer-module--footer-legal--AKi57";